import MemoList from "../MemoList";

export default function Director() {
  return <MemoList memoType="Director" />;
}
